import { useMemo } from "react";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

export const useCheckoutLabels = (): Record<string, string> => {
    const { t } = useStringTranslation();

    return useMemo(
        () => ({
            back: t("checkout-back"),
            contactDetailsTitle: t("checkout-contact-details-title"),
            companyName: t("checkout-company-name"),
            contactName: t("checkout-contact-name"),
            email: t("checkout-email"),
            phone: t("checkout-phone"),
            phonePlaceholder: t("checkout-phone-placeholder"),
            deliveryAddressTitle: t("checkout-delivery-address-title"),
            street: t("checkout-street"),
            streetPlaceholder: t("checkout-street-placeholder"),
            postalCode: t("checkout-postal-code"),
            postalCodePlaceholder: t("checkout-postal-code-placeholder"),
            city: t("checkout-city"),
            cityPlaceholder: t("checkout-city-placeholder"),
            country: t("checkout-country"),
            additionalNotes: t("checkout-additional-notes"),
            additionalNotesPlaceholder: t(
                "checkout-additional-notes-placeholder",
            ),
            countryPlaceholder: t("checkout-country-placeholder"),
            savePrimaryAddress: t("checkout-save-primary-address"),
            savePrimaryAddressDescription: t(
                "checkout-save-primary-address-description",
            ),
            placeOrder: t("checkout-place-order"),
            requiredField: t("checkout-order-required-field"),
            submitError: t("checkout-submit-error"),
            orderSummaryTitle: t("cart-order-summary-title"),
            orderSummaryDiscount: t("cart-order-summary-discount"),
            orderSummaryTotal: t("cart-order-summary-total"),
            orderDisclaimer: t("cart-order-disclaimer"),
            refurbishedStatus: t("refurbished"),
        }),
        [t],
    );
};
